import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
export default function CartasContempladas() {
  const { t } = useTranslation('cartas');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#F6F2EC]">

      {/* Hero Section */}
      <section className="bg-[#FBF8F3] border-b border-[#E7E1D9] pt-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-32">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-semibold text-[#0B0B0B] leading-tight mb-6">
              {t('hero.title')}
            </h1>
            <p className="text-lg text-[#2E2E2E] leading-relaxed mb-12">
              {t('hero.subtitle')}
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="/diagnostico"
                className="inline-flex items-center justify-center px-8 py-4 bg-[#F97700] hover:bg-[#E56E00] text-white font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta_primary')}
              </a>
              <a
                href="https://wa.me/5511930322408"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 bg-[#0B0B0B] hover:bg-[#171717] text-white font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                {t('hero.cta_secondary')}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Curadoria Técnica */}
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-2xl mb-20">
            <p className="text-xs font-semibold text-[#F97700] uppercase tracking-wider mb-4">
              {t('curation.label')}
            </p>
            <h2 className="text-4xl font-semibold text-[#0B0B0B] leading-tight">
              {t('curation.title')}
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {(t('curation.items', { returnObjects: true }) as Array<{ title: string; description: string }>).map((item, index) => (
              <div
                key={index}
                className="bg-[#FBF8F3] border border-[#E7E1D9] p-10 hover:border-[#F97700] transition-colors"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FFF1E6] text-[#F97700] font-semibold shrink-0">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <h3 className="text-xl font-semibold text-[#0B0B0B] leading-tight pt-1">
                    {item.title}
                  </h3>
                </div>
                <p className="text-[#2E2E2E] leading-relaxed pl-14">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processo de Validação */}
      <section className="py-32 bg-[#FBF8F3] border-y border-[#E7E1D9]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-2xl mb-20">
            <p className="text-xs font-semibold text-[#F97700] uppercase tracking-wider mb-4">
              {t('validation.label')}
            </p>
            <h2 className="text-4xl font-semibold text-[#0B0B0B] leading-tight">
              {t('validation.title')}
            </h2>
          </div>

          <div className="space-y-6">
            {(t('validation.steps', { returnObjects: true }) as Array<{ title: string; description: string }>).map((step, index) => (
              <div
                key={index}
                className="flex items-start gap-6 bg-white border border-[#E7E1D9] p-8 hover:border-[#F97700] transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#0B0B0B] text-white font-semibold shrink-0">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-[#0B0B0B] mb-3">
                    {step.title}
                  </h3>
                  <p className="text-[#2E2E2E] leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Governança e Transparência */}
      <section className="py-32">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="bg-white border-l-4 border-[#F97700] p-10">
            <p className="text-xs font-semibold text-[#F97700] uppercase tracking-wider mb-4">
              {t('governance.label')}
            </p>
            <h3 className="text-2xl font-semibold text-[#0B0B0B] mb-6">
              {t('governance.title')}
            </h3>
            <div className="space-y-4 text-[#2E2E2E] leading-relaxed">
              {(t('governance.points', { returnObjects: true }) as string[]).map((point, index) => (
                <p key={index}>{point}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-32 bg-[#0B0B0B]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl font-semibold text-white mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-lg text-white/80 mb-12 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/diagnostico"
              className="inline-flex items-center justify-center px-8 py-4 bg-[#F97700] hover:bg-[#E56E00] text-white font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('cta.button_primary')}
            </a>
            <a
              href="https://wa.me/5511930322408"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-white hover:bg-white/90 text-[#0B0B0B] font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              {t('cta.button_secondary')}
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}
